import React, { useEffect, useState } from 'react';
import { styled } from '@nykaa/nes-ui-components';
import { MWEB } from 'constants/devices';
import Widgets from 'components/Widgets';
import { TRACKING_PAGE_TYPES } from 'components/CartOperations/constants';

interface PopularSuggestionProps {
  fetchSearchSuggestionWidgets: (
    params: { [key: string]: string },
    isPaginationEnabled?: boolean
  ) => Promise<void>;
  searchSuggestionWidgets: any;
  isSearchWidgetLoading: boolean;
  isPaginationEnabled: boolean;
  remainingInventoryIds: string[];
}

const Root = styled.div`
  display: block;
`;

const View = ({
  fetchSearchSuggestionWidgets,
  isSearchWidgetLoading,
  searchSuggestionWidgets,
  remainingInventoryIds,
  isPaginationEnabled,
}: PopularSuggestionProps) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const widgetParams = {
    page_type: 'search-input-page-dn',
    page_data: 'search-input-page-data',
    page_section: '*',
    device: 'mobile',
    platform: MWEB,
    api_version: isPaginationEnabled ? 'V2' : '',
  };
  const [isWidgetFetched, setWidgetFetched] = useState(false);
  useEffect(() => {
    if (
      !isWidgetFetched &&
      !isSearchWidgetLoading &&
      !searchSuggestionWidgets
    ) {
      setWidgetFetched(true);
      fetchSearchSuggestionWidgets(widgetParams, isPaginationEnabled);
    }
  }, [
    fetchSearchSuggestionWidgets,
    isPaginationEnabled,
    isSearchWidgetLoading,
    isWidgetFetched,
    searchSuggestionWidgets,
    widgetParams,
  ]);

  if (searchSuggestionWidgets?.length > 0) {
    return (
      <Root>
        <Widgets
          widgets={searchSuggestionWidgets}
          pageName={TRACKING_PAGE_TYPES.SEARCH_INPUT}
          remainingInventoryIds={remainingInventoryIds}
          queryParamsObject={widgetParams}
        />
      </Root>
    );
  }
  return null;
};

export default View;
